export const genWidgetcellChangeHandler = (handleEdit, dataIndex, type) => (me, newValue) => {
	const widgetcell = me.up('widgetcell')
	const record = widgetcell.getRecord()
	const { data: { id } = {}, data } = record || {}
	const oldValue = widgetcell.getValue()

	oldValue !== newValue && handleEdit && handleEdit({ id, name: dataIndex, newValue, oldValue, data, record, type })
}

export const truePromise = () => Promise.resolve(true)

// tooltip配置: 直接配置tooltip: str | fn，或配置_tooltip:true, text: str | fn
export const getBindedProps = (oldProps, that, key, forViewModel, checkGridData = truePromise) => {
	const { bind = {}, _tooltip, icon, handler, /* dataIndex,  */...propList } = oldProps
	const props = {}

	icon != undefined && (typeof icon === 'function' ? (bind.iconCls = `x-fa fa-{${forViewModel ? '' : 'record.'}icon${key}}`) : props.iconCls = `x-fa fa-${icon}`)
	// dataIndex != undefined && (Array.isArray(dataIndex) ? (bind.dataIndex = `{${forViewModel ? '' : 'record.'}dataIndex${key}}`) : props.dataIndex = dataIndex)
	handler && (props.handler = me => {
		const record = me.up('widgetcell').getRecord()
		const { data } = record
		const grid = me.up('grid')
		checkGridData([data.id]).then(r => r && handler(that, data, record, grid))
	})
	Object.entries(propList).forEach(([k, v]) => v !== undefined && (
		typeof v === 'function'
			? (bind[k] = `{${forViewModel ? '' : 'record.'}${k}${key}}`)
			: props[k] = v
	))

	if (_tooltip)
		for (const o of [props, bind]) o.text && (o.tooltip = o.text, delete o.text)

	Object.keys(bind).length && (props.bind = bind)
	return props
}

// 根据data计算edit参数
export const getSyncfusionEditProps = (edit, data) => Object.entries(edit).reduce((sum, [k, v]) => {
	sum[k] = typeof v === 'function' ? v(data) : v
	return sum
}, {})